import copy from 'clipboard-copy';
import React, {useState} from 'react';
import {cn, styles} from '../../Utilities';
import * as cls from './RsnCopyButton.css';

export interface CopyButtonProps {
    value: string;
    size?: 16 | 20;
}

export function RsnCopyButton({value, size = 20}: CopyButtonProps) {
    const [copyStatus, setCopyStatus] = useState(false);

    const copyButton = async (value: string) => {
        if (value) {
            await copy(value);
        }
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 1200);
    };

    const sizeCls = styles({
        16: 'size-4',
        20: 'size-5',
    })[size];

    return (
        <button
            type='button'
            className={cn(cls.copyButton, sizeCls, {
                [cls.copied]: copyStatus,
            })}
            onClick={() => copyButton(value)}
        />
    );
}
